import { LocationDto } from "@braoshzmvavz/picnube-common";
import { Group } from "@mantine/core";
import React from "react";
import ReactCountryFlag from "react-country-flag";
import { HiChevronRight } from "react-icons/hi";

export default function LocationInfo(props: {
  location: LocationDto;
  rightIcon: React.ReactNode;
  onClick: (location: LocationDto) => void;
}) {
  return (
    <Group align="end" className="flex w-full">
      <div
        className="flex flex-row items-center justify-between w-full p-4
            dark:hover:bg-grey-900  hover:bg-grey-200
            rounded-lg border-none max-h-fit
            "
        onClick={() => {}}
      >
        <div className="flex flex-col items-start overflow-hidden">
          <div className="text-lg whitespace-nowrap text-nowrap text-ellipsis overflow-hidden w-full">{props.location.name}</div>
          <div className="text-sm text-grey-600 flex flex-row gap-2 items-center mt-1">
            <ReactCountryFlag
              style={{ fontFamily: "Twemoji Country Flags" }}
              countryCode={props.location.countryCode}
            ></ReactCountryFlag>
            <div>
              {props.location.region}, {props.location.country}
            </div>
          </div>
        </div>
        <div
          className="flex items-center gap-1 p-2 pl-4 dark:hover:bg-grey-800 hover:bg-grey-300 cursor-pointer rounded-xl w-fit"
          onClick={(e) => {
            e.stopPropagation();
            props.onClick(props.location);
          }}
        >
          View more
          <HiChevronRight className="text-xl"></HiChevronRight>
        </div>
      </div>
    </Group>
  );
}
